import AuthService from "./auth.service";
import {RawAxiosRequestHeaders} from "axios";

export default function authHeader() {
    let user = AuthService.getCurrentUser();
    if (user && user.access_token) {
        // return {Authorization: 'Bearer ' + user.access_token}; // for Spring Boot back-end
        return {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Origin': '*',
            'email': user.email,
            Authorization: 'Bearer ' + reverseString(reverseString(user.access_token).substring(0, 150))
        } as RawAxiosRequestHeaders; // for Spring Boot back-end
        // return {'x-access-token': user.accessToken};       // for Node.js Express back-end
    } else {
        // return {};
        return {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Origin': '*',
            Authorization: ''
        } as RawAxiosRequestHeaders;
    }
}

function reverseString(str: string): string {
    let reversed = '';
    for (let i = str.length - 1; i >= 0; i--) {
        reversed += str[i];
    }
    return reversed;
}
